<div class="SAS_Navbar">
  <!-- Header -->
  <app-outer-pages-header></app-outer-pages-header>

  <section class="about-jtc top-background no-printme">
    <div class="background-image">
      <div class="container">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb custom-breadcrumb">
            <li class="breadcrumb-item">
              <a [routerLink]="['/']">الرئيسية</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              انضم لفريقنا
            </li>
          </ol>
        </nav>
        <h1 class="sub-title">انضم لفريقنا</h1>
      </div>
    </div>
  </section>

  <div class="">
    <!-- <div class="container">
      <h4 class="sub-title"> انضم لفريقنا </h4>
    </div> -->

    <div class="container">
      <div class="WhoAreWe section-padding">
        <!-- <h3 class="text-center heading-title mb-4 text-site-color borderAfter">طلب الانضمام معنا في تقديم خدماتك كمختص في المنصة علاجية</h3> -->
        <div class="section-title">
          <h2>طلب الانضمام معنا في تقديم خدماتك كمختص في المنصة علاجية</h2>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <!-- <h3 class="heading-title mb-4 text-site-color">مرحبا بكم ...</h3> -->
            <div class="intro-text">
              <h3 class="dear">عزيزي المختص/المشرف :</h3>
              <p>
                شركة سلاسة هي شركة سعودية تختص في تقديم خدمات علاج اضطرابات
                التخاطب والسمع. والشركة تقدم لكم هنا
                <a
                  href="assets/files/SpecialistJoinRequest.docx"
                  target="_blank"
                  class="text-site-color"
                  >(طلب الانضمام لفريقها)</a
                >
                في علاج مرضى التلعثم من خلال المشاركة كمختص/مشرف عبر منصة علاجية
                قامت الشركة بانشاءها لهذا الغرض.
              </p>
              <p>
                والمنصة العلاجية تهدف إلى علاج مرضى التلعثم على ثلاث مراحل :
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="treatment-levels section-padding">
      <div class="container">
        <div class="row g-24">
          <div class="col-lg-4 col-md-6 col-12">
            <div class="level-timeline">
              <div class="timeline-header">
                <div class="num">1</div>
                <div class="line"></div>
              </div>

              <div class="level-content">
                <h3 class="level-title">المرحلة الأولى (التسجيل)</h3>
                <p class="level-desc">
                  تسجيل المريض وتعبئة تاريخه المرضي وبياناته .
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <div class="level-timeline">
              <div class="timeline-header">
                <div class="num">2</div>
                <div class="line"></div>
              </div>

              <div class="level-content">
                <h3 class="level-title">المرحلة الثانية (التشخيص)</h3>
                <p class="level-desc">
                  حيث يتم تشخيص المريض بشكل آلي بحيث يقوم بالمرور على مراحل
                  التشخيص المعتمدة في برنامج المنصة. ويقوم أيضا برفع مقطع فيديو
                  له للتعريف بحالته. وتحتاج عملية تحليل المعلومات ومقطع الفيديو
                  ٢٠ دقيقة. وبعد ذلك يقوم المختص بتحديد موعد مقابله مع المريض من
                  خلال المنصة والتاكد من حالته والبينات التي وصلته من المريض
                  سابقا ومدى صدقيتها. وهذه المقابلة مدتها ١٥ دقيقة. وفي النهاية
                  يتم بشكل آلي خروج تقرير عن حالته. والعرض المقدم لكم لتقديم
                  خدمتكم لهذه المرحلة هي 20 دولار أمريكي بعد استكمالكم المقابلة
                  للمريض عبر المنصة ودراسة حالته في ملفه وتقديم التقرير الخاص
                  به.
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <div class="level-timeline">
              <div class="timeline-header">
                <div class="num">3</div>
                <div class="line"></div>
              </div>

              <div class="level-content">
                <h3 class="level-title">المرحلة الثالثة (العلاج)</h3>
                <p class="level-desc">
                  تتم هذه المرحلة من خلال جلسات علاجية تتم بشكل آلي للمريض يقوم
                  من خلالها بالتدرب على تحسين حالته. وفي نهاية كل جلسة يرفع
                  المريض ملفا مصورا عن حالته يتطلب بعد ذلك قيام المختص بمراجعة
                  حالته من خلال النظام دون مقابلة المريض لتحديد إما بقائه في
                  الجلسة الحالية أو تخطيه إلى الجلسة التالية وهكذا إلى أن يتم
                  الجلسات العلاجية المطلوبة. وفي المعتاد مراجعة جلسات المرضى لا
                  تتطلب سوى خمس إلى عشر دقائق من وقت المختص. والعرض المقدم لكم
                  لتقييم الجلسة هو مبلغ 5 دولار أمريكي.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-padding end-text">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <!-- <p>
              وهذا الأسلوب في العلاج يتبع طريقة
              <span _ngcontent-vlt-c182="" class="text-site-color"
                >Speech-Hand Synchronization SHS</span
              >

              , قام بابتكاره وتطويره الدكتور منصور الدوخي والدكتور عبدالعزيز
              المضحي حيث قدما فيه رسائل وبحوث عالمية . وذلك لتوحيد عملية الرحلة
              العلاجية لمرض التلعثم بحيث تمر بمراحل محددة لكافة المرضى الذين
              يعانون من هذا الاضطراب.
            </p> -->
            <p>
              لذلك تتشرف شركة سلاسة بطلب انضمامكم إلى فريقها. وفي حال موافقتكم
              سنقوم معا بالخطوات التالية:
            </p>

            <!-- <div class="table-responsive">
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>الخطوات</th>
                    <th>الأعمال التي يقوم بها المختص</th>
                    <th>الأعمال التي تقوم بها الشركة</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>
                      <p>
                        تعبئة
                        <a
                          href="assets/files/SpecialistJoinRequest.docx"
                          target="_blank"
                          class="text-site-color"
                        >
                          النموذج
                        </a>
                        وأرفاق النسخ الاليكترونية المحددة في النموذج على البريد
                        الاليكتروني التالي للشركة : spec_join@mcsc-saudi.com
                      </p>
                      <p>يرجى ارفاق نسخة اليكترونية من التالي:</p>
                      <p class="mb-1">نسخة من كافة المؤهلات والخبرات.</p>
                      <p class="mb-1">نسخة من الهوية/جواز السفر.</p>
                      <p class="mb-1">
                        نسخة من انتسابكم لـلجهات والمننظمات التي ذكرتها في
                        النموذج أعلاه.
                      </p>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td></td>
                    <td>
                      مراجعة بيانات المختص وعلى أثرها سيتم التواصل معه لمقابلته
                      عبر وسائل الاتصال عن بعد مثل zoom ونحوه للتعرف عليكم بشكل
                      أكبر وارسال نسخة من الاتفاقية للمختص للتوقيع عليها او
                      الاعتذار له
                    </td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>توقيع اتفاقية تقديم خدماتكم للعمل في المنصة</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td></td>
                    <td>تحديد طريقة التدرب للعمل في المنصة</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td></td>
                    <td>
                      ادخال بيانات المختص في المنصة تمهيدا للشروع في العمل
                    </td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>مباشرة العمل</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div> -->

            <div class="dga-table my-3">
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>الخطوات</th>
                      <th>الأعمال التي يقوم بها المختص</th>
                      <th>الأعمال التي تقوم بها الشركة</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>
                        <p>
                          تعبئة
                          <a
                            href="assets/files/SpecialistJoinRequest.docx"
                            target="_blank"
                            class="text-site-color"
                          >
                            النموذج
                          </a>
                          وأرفاق النسخ الاليكترونية المحددة في النموذج على
                          البريد الاليكتروني التالي للشركة : info@cpt-it.com
                        </p>
                        <p>يرجى ارفاق نسخة اليكترونية من التالي:</p>
                        <p class="mb-1">نسخة من كافة المؤهلات والخبرات.</p>
                        <p class="mb-1">نسخة من الهوية/جواز السفر.</p>
                        <p class="mb-1">
                          نسخة من انتسابكم لـلجهات والمننظمات التي ذكرتها في
                          النموذج أعلاه.
                        </p>
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td></td>
                      <td>
                        مراجعة بيانات المختص وعلى أثرها سيتم التواصل معه
                        لمقابلته عبر وسائل الاتصال عن بعد مثل zoom ونحوه للتعرف
                        عليكم بشكل أكبر وارسال نسخة من الاتفاقية للمختص للتوقيع
                        عليها او الاعتذار له
                      </td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>توقيع اتفاقية تقديم خدماتكم للعمل في المنصة</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td></td>
                      <td>تحديد طريقة التدرب للعمل في المنصة</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td></td>
                      <td>
                        ادخال بيانات المختص في المنصة تمهيدا للشروع في العمل
                      </td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>مباشرة العمل</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <p class="text-center mb-0">
              شاكرين تعاونكم ونرحب بكم في فريق شركة سلاسة.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <app-outer-pages-footer></app-outer-pages-footer>
</div>
